var _style, _path, _path2, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDepartments = function SvgDepartments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "departments_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".departments_svg__st0{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 23.5h-13c-.6 0-1-.4-1-1v-21c0-.6.4-1 1-1h21c.6 0 1 .4 1 1v16",
    className: "departments_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 5.5c0-1.1-.9-2-2-2s-2 .9-2 2V9c0 .3.2.5.5.5h3c.3 0 .5-.2.5-.5zM12.5 5.5c0-1.1-.9-2-2-2s-2 .9-2 2V9c0 .3.2.5.5.5h3c.3 0 .5-.2.5-.5zM6.5 15.5c0-1.1-.9-2-2-2s-2 .9-2 2V19c0 .3.2.5.5.5h3c.3 0 .5-.2.5-.5zM12.5 15.5c0-1.1-.9-2-2-2s-2 .9-2 2V19c0 .3.2.5.5.5h3c.3 0 .5-.2.5-.5zM21.5 17.5v-6c0-1.1-.9-2-2-2h-1c-1.1 0-2 .9-2 2v6",
    className: "departments_svg__st0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 5,
    r: 2,
    className: "departments_svg__st0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 17.5h-9v6h8c.6 0 1-.4 1-1zM14.5 19.5h9M14.5 21.5h9M14.5.5v17",
    className: "departments_svg__st0"
  })));
};
export default SvgDepartments;